export const environment = {
    production: false,
    // apiURL: 'http://192.168.0.27:5000/',
    apiURL: 'https://api-dev.crizac.com/',
    fileBaseUrl: 'https://crizac-assets.s3.ap-south-1.amazonaws.com/system',
    callBaseUrl: 'https://crizac-assets.s3.ap-south-1.amazonaws.com/yeasterdownload/',
    zegoCloud: 'https://connect.crizac.com/',
    apiPHPURL: 'https://accounts.crizac.com/',
    apiPHPURLv2: 'https://accounts.crizac.com/api_mongo/',
    fileDownloadUrl: 'https://crizac-assets.s3.ap-south-1.amazonaws.com',
    oneSignalAppId: '65c6e8f2-5801-46f8-a049-633176bb17e0',
    chatBaseUrl: 'wss://api-console.crizac.com/support-chat-notification',
    transportBaseURL: "https://api-dev.crizac.com/",
    agentPortallink: 'https://agent-dev-new.crizac.com/',
    agentPortallinkUC:'https://portal.ucol.co.uk/',
    agentPortallinkGA:'https://portal.gasolutions.in/',
    predictorApiKey: '1ad11872-0537-4406-b01e-de5c52995492',
    predictorApiUrl: 'https://eligibility-predictor.crizac.com',
    fileProfileUrl: 'https://crizac-assets.s3.ap-south-1.amazonaws.com/users/profiles/',
    sopURL:'https://sop-generator.crizac.com/', 
    fileUsersUrl: 'https://crizac-assets.s3.ap-south-1.amazonaws.com/system',
    chatURL: "https://api.crizac.com/",
    englishVerificationURL: "http://122.176.98.135:3031/",
    uelVerificaitonURL: "https://api-console.crizac.com",
    interviewRecordUrl: 'https://interview.ucol.co.uk/',
    interviewRecordUrlOld: 'https://ucolinterview.nyc3.digitaloceanspaces.com/',
    enableNewEng: true,
    enableFormControlFeature: true,
    showconsole: true,
    ShowEligibilityMsgComponent:true,
    showAiChat:true,
    similarApplications:true,
    whatsappBaseUrl: 'https://waba.crizac.com/api/v1/whatsapp',
    wsBaseUrl: 'https://waba.crizac.com', // Socket.IO backend URL
    whatsApiBaseUrl: 'https://waba.crizac.com/api/v1',
    APP_VERSION: "0.8.97",
    showConsoleAutomation: true,
    statusUpdateDynamicForm: true,
};
